import { useTheme } from '@mui/material';

interface IncorrectType {
  size?: number,
}

const Incorrect = ({ size = 318 }: IncorrectType) => {
  const theme = useTheme();
  return (
    <svg
      width={size + 1}
      height={size}
      viewBox={`0 0 ${size + 1} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_596_8855)">
        <path
          d="M137.318 306L308.306 184.519C310.039 175.324 311 165.836 311 156.143C311 72.4571 243.274 4.61822 159.727 4.61821C76.1807 4.6182 8.45452 72.457 8.45451 156.143C8.4545 232.197 64.3925 295.155 137.318 306Z"
          fill="url(#paint0_linear_596_8855)"
        />
        <path
          d="M305 156.143C305 164.614 304.235 172.935 302.836 181.045L135.835 299.693C66.9728 288.285 14.4545 228.363 14.4545 156.143C14.4545 75.7613 79.5038 10.6182 159.727 10.6182C239.951 10.6182 305 75.7614 305 156.143Z"
          stroke={`${theme.palette.primary.main ?? '#9BCAFF'}`}
          stroke-width="12"
        />
      </g>
      <mask
        id="path-3-outside-1_596_8855"
        maskUnits="userSpaceOnUse"
        x="87.957"
        y="80.8818"
        width="148"
        height="148"
        fill="black"
      >
        <rect fill="white" x="87.957" y="80.8818" width="148" height="148" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M93.957 209.334L107.479 222.882L161.84 168.418L216.199 222.878L229.72 209.331L175.362 154.87L229.716 100.414L216.194 86.8664L161.84 141.323L107.483 86.8629L93.9613 100.41L148.319 154.87L93.957 209.334Z"
        />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.957 209.334L107.479 222.882L161.84 168.418L216.199 222.878L229.72 209.331L175.362 154.87L229.716 100.414L216.194 86.8664L161.84 141.323L107.483 86.8629L93.9613 100.41L148.319 154.87L93.957 209.334Z"
        fill="white"
      />
      <path
        d="M107.479 222.882L110.31 225.708L107.479 228.544L104.648 225.708L107.479 222.882ZM93.957 209.334L91.1259 212.16L88.3055 209.334L91.1259 206.509L93.957 209.334ZM161.84 168.418L159.009 165.592L161.84 162.755L164.672 165.592L161.84 168.418ZM216.199 222.878L219.03 225.704L216.199 228.541L213.367 225.704L216.199 222.878ZM229.72 209.331L232.551 206.505L235.372 209.331L232.551 212.157L229.72 209.331ZM175.362 154.87L172.531 157.696L169.711 154.87L172.531 152.044L175.362 154.87ZM229.716 100.414L232.547 97.588L235.368 100.414L232.547 103.239L229.716 100.414ZM216.194 86.8664L213.363 84.0406L216.194 81.2042L219.025 84.0406L216.194 86.8664ZM161.84 141.323L164.672 144.149L161.84 146.985L159.009 144.149L161.84 141.323ZM107.483 86.8629L104.652 84.0371L107.483 81.2007L110.314 84.0371L107.483 86.8629ZM93.9613 100.41L91.1302 103.236L88.3098 100.41L91.1302 97.5845L93.9613 100.41ZM148.319 154.87L151.15 152.044L153.97 154.87L151.15 157.696L148.319 154.87ZM104.648 225.708L91.1259 212.16L96.7881 206.509L110.31 220.056L104.648 225.708ZM164.672 171.243L110.31 225.708L104.648 220.056L159.009 165.592L164.672 171.243ZM213.367 225.704L159.009 171.243L164.672 165.592L219.03 220.053L213.367 225.704ZM232.551 212.157L219.03 225.704L213.367 220.053L226.889 206.505L232.551 212.157ZM178.193 152.044L232.551 206.505L226.889 212.157L172.531 157.696L178.193 152.044ZM232.547 103.239L178.193 157.696L172.531 152.044L226.885 97.588L232.547 103.239ZM219.025 84.0406L232.547 97.588L226.885 103.239L213.363 89.6921L219.025 84.0406ZM159.009 138.497L213.363 84.0406L219.025 89.6921L164.672 144.149L159.009 138.497ZM110.314 84.0371L164.672 138.497L159.009 144.149L104.652 89.6887L110.314 84.0371ZM91.1302 97.5845L104.652 84.0371L110.314 89.6887L96.7924 103.236L91.1302 97.5845ZM145.488 157.696L91.1302 103.236L96.7924 97.5845L151.15 152.044L145.488 157.696ZM91.1259 206.509L145.488 152.044L151.15 157.696L96.7881 212.16L91.1259 206.509Z"
        fill="white"
        mask="url(#path-3-outside-1_596_8855)"
      />
      <path
        d="M143.208 284.443C166.87 215.233 237.326 174.982 308.673 185.469L137.618 306C138.921 298.786 140.756 291.589 143.208 284.443Z"
        fill={`${theme.palette.primary.main ?? '#9BCAFF'}`}
      />
      <defs>
        <filter
          id="filter0_d_596_8855"
          x="0.454468"
          y="0.618164"
          width="318.546"
          height="317.382"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_596_8855"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_596_8855"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_596_8855"
          x1="160.002"
          y1="190.844"
          x2="233.1"
          y2="305.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#F84A4B" />
          <stop offset="0.94" stop-color="#C34648" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Incorrect;
